import { browser } from "$app/environment";

/**
 * 
 * @param {number} value 
 * @param {string} fx_code 
 * @param {'symbol'|'code'|'name'} display
 * @param {boolean} keep_cents always show the currency's minor units, so a
 *  column of totals lines up ($10.00 under $8.47, not $10)
 * @returns
 */
export const format_price = (value, fx_code = 'USD', display = 'symbol', keep_cents = false) => {

    let locale = 'en-CA'; // use US$ instead of $ for ssr
    if (browser) locale = window?.navigator?.language || 'en-CA';

    /** @type {Intl.NumberFormatOptions} */
    let opts = {
        style: 'currency',
        currency: fx_code,
        currencyDisplay: display,
        // undefined = the currency's own digits (2 for USD, 0 for JPY)
        minimumFractionDigits: keep_cents ? undefined : value % 1 === 0 ? 0 : 2,
    }

    try {
        return new Intl.NumberFormat(locale, opts).format(value);
    } catch (error) {
        // Fallback to a default locale if the provided locale is incorrect
        return new Intl.NumberFormat('en-CA', opts).format(value);
    }
};